<template>
	<div>
		<v-dialog v-model="overlay">
			<v-card class="d-flex">
				<v-card-actions class="ml-auto">
					<v-btn color="green darken-1" text @click="onOverlay()">Close</v-btn>
				</v-card-actions>
			</v-card>
			<v-card class="d-flex">
				<table width="100%" style="background:#1C1C28; min-width:320px;" cellspacing="0" cellpadding="0">
					<tr>
						<td>
							<table width="100%" align="center" style="background:#22222D;" cellpadding="0" cellspacing="0">
								<tr>
									<td style="background:#1C1C28; padding:20px;">
										<table width="100%" cellpadding="0" cellspacing="0">
											<tr>
												<td style="background:#2B2B37; padding:0 10px 10px 10px; border-radius:4px;">
													<table width="100%" cellpadding="0" cellspacing="0">
														<tr>
															<td colspan="7" valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td align="center"
																		    style="background:#EEE; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																			Total trucks amount
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																			{{ info.total.total }}
																		</td>
																	</tr>
																</table>
															</td>
														</tr>
														<tr>
															<td colspan="3" valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td align="center"
																		    style="background:#A5D6A7; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																			On the road
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																			{{ info.total.on_road }}
																		</td>
																	</tr>
																</table>
															</td>
															<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
															<td colspan="3" valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td align="center"
																		    style="background:#EF9A9A; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																			Not on the road
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																			{{ info.total.not_on_road }}
																		</td>
																	</tr>
																</table>
															</td>
														</tr>
														<tr>
															<td valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td align="center"
																		    style="background:#F5CA8A; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																			Company:
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																			{{ info.total.on_road_company }}
																		</td>
																	</tr>
																</table>
															</td>
															<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
															<td valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td align="center"
																		    style="background:#93CAF6; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																			Not company:
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																			{{ info.total.on_road_not_company }}
																		</td>
																	</tr>
																</table>
															</td>
															<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
															<td valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td colspan="3">
																			<table width="100%" cellpadding="0" cellspacing="0">
																				<tr>
																					<td align="center"
																					    style="background:#F5CA8A; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																						Company:
																					</td>
																				</tr>
																				<tr>
																					<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																						{{ info.total.not_on_road_company }}
																					</td>
																				</tr>
																			</table>
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0 0 0;">
																			<table width="100%" cellpadding="0" cellspacing="0">
																				<tr>
																					<td align="center"
																					    style="background:#93CAF6; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																						Uncovered:
																					</td>
																				</tr>
																				<tr>
																					<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																						{{ info.total.not_on_road_company_uncovered }}
																					</td>
																				</tr>
																			</table>
																		</td>
																		<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
																		<td style="padding:10px 0 0 0;">
																			<table width="100%" cellpadding="0" cellspacing="0">
																				<tr>
																					<td align="center"
																					    style="background:#EF9A9A; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																						On the yard
																					</td>
																				</tr>
																				<tr>
																					<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																						{{ info.total.not_on_road_company_on_yard }}
																					</td>
																				</tr>
																			</table>
																		</td>
																	</tr>
																</table>
															</td>
															<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
															<td valign="top" style="padding:10px 0 0 0;">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<tr>
																		<td colspan="3">
																			<table width="100%" cellpadding="0" cellspacing="0">
																				<tr>
																					<td align="center"
																					    style="background:#93CAF6; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																						Not company:
																					</td>
																				</tr>
																				<tr>
																					<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																						{{ info.total.not_on_road_not_company }}
																					</td>
																				</tr>
																			</table>
																		</td>
																	</tr>
																	<tr>
																		<td style="padding:10px 0 0 0;">
																			<table width="100%" cellpadding="0" cellspacing="0">
																				<tr>
																					<td align="center"
																					    style="background:#93CAF6; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																						Uncovered
																					</td>
																				</tr>
																				<tr>
																					<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																						{{ info.total.not_on_road_not_company_uncovered }}
																					</td>
																				</tr>
																			</table>
																		</td>
																		<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
																		<td style="padding:10px 0 0 0;">
																			<table width="100%" cellpadding="0" cellspacing="0">
																				<tr>
																					<td align="center"
																					    style="background:#EF9A9A; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																						On the yard
																					</td>
																				</tr>
																				<tr>
																					<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																						{{ info.total.not_on_road_not_company_on_yard }}
																					</td>
																				</tr>
																			</table>
																		</td>
																	</tr>
																</table>
															</td>
														</tr>

														<tr>
															<td colspan="7" valign="top">
																<table width="100%" cellpadding="0" cellspacing="0">
																	<td colspan="3" valign="top" style="padding:10px 0 0 0;">
																		<table width="100%" cellpadding="0" cellspacing="0">
																			<tr>
																				<td align="center"
																				    style="background:#93CAF6; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																					Fleet
																				</td>
																			</tr>
																			<tr>
																				<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																					{{ info.status['fleet_total'] }}
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<table width="100%" cellpadding="0" cellspacing="0">
																						<tr
																								v-for="(item, index) in info.status['fleet']"
																								:key="index"
																						>
																							<td width="10"
																							    style="padding:0 8px 0 0; font:600 16px/20px; color:#ffffffb3;">
																								&bull;
																							</td>
																							<td style="font:400 14px/20px; color:#ffffffb3;">
																								{{ item['status'] }} : {{ item['total'] }}
																							</td>
																						</tr>
																					</table>
																				</td>
																			</tr>
																		</table>
																	</td>
																	<td width="10" valign="top" style="padding:10px 0 0 0;"></td>
																	<td colspan="3" valign="top" style="padding:10px 0 0 0;">
																		<table width="100%" cellpadding="0" cellspacing="0">
																			<tr>
																				<td align="center"
																				    style="background:#EF9A9A; padding:4px; font:600 16px/20px; color:#1C1C28; border-radius:4px;">
																					Dispatch
																				</td>
																			</tr>
																			<tr>
																				<td style="padding:10px 0; font:bold 16px/20px; color:#fff;">
																					{{ info.status['dispatch_total'] }}
																				</td>
																			</tr>
																			<tr>
																				<td>
																					<table width="100%" cellpadding="0" cellspacing="0">
																						<tr
																								v-for="(item, index) in info.status['dispatch']"
																								:key="index"
																						>
																							<td width="10"
																							    style="padding:0 8px 0 0; font:600 16px/20px; color:#ffffffb3;">
																								&bull;
																							</td>
																							<td style="font:400 14px/20px; color:#ffffffb3;">
																								{{ item['status'] }} : {{ item['total'] }}
																							</td>
																						</tr>
																					</table>
																				</td>
																			</tr>
																		</table>
																	</td>
																</table>
															</td>
														</tr>

													</table>
												</td>
											</tr>
										</table>
									</td>
								</tr>
								<tr>
									<td>
										<table width="100%" cellpadding="0" cellspacing="0">
											<tr>
												<td align="center"
												    style="font:14px/18px; padding: 10px 0 0 0;">
													<hr>
													<table width="100%" cellpadding="0" cellspacing="0">
														<tr>
															<th width="5%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																ID
															</th>
															<th width="8%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Date
															</th>
															<th width="5%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Truck
															</th>
															<th width="5%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Company owned
															</th>
															<th width="13%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Company
															</th>
															<th width="13%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Driver name
															</th>
															<th width="6%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Driver type
															</th>
															<th width="10%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Reason
															</th>
															<th width="12%" align="center"
															    style="font:14px/18px; border: 1px solid #2d2d2d; padding: 2px;">
																Description
															</th>
														</tr>

														<tr
																v-for="(item, index) in info.list"
																:key="index"
														>
															{{ item['status'] }}
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.id }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.date }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.truck_number }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.company_owned }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.customer }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.driver }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.driver_type }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.reason }}
															</td>
															<td align="center"
															    style="font:400 14px/20px; border: 1px solid #2d2d2d; padding: 2px;">
																{{ item.description }}
															</td>
														</tr>
													</table>
												</td>
											</tr>
										</table>
									</td>
								</tr>
							</table>
						</td>
					</tr>
					<tr>
						<td class="hm" style="line-height:0;">
							<div style="white-space:nowrap; font:15px/0 courier;">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
								&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
							</div>
						</td>
					</tr>
				</table>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
	name: "PreviewGeneratedInvoice",
	props: {
		overlay: Boolean,
		info: Object
	},
	methods: {
		onOverlay() {
			this.$emit("updateOverlay");
		}
	}
};
</script>

<style scoped lang="scss">
@import "previewGeneratedInvoice";
</style>
